import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

function filterReducer(state, action) {
  switch (action.type) {
    case "LOADING_TRUE": {
      return {
        ...state,
        loading: true,
      };
    }
    case "LOADING_FALSE": {
      return {
        ...state,
        loading: false,
      };
    }
    case "TOGGLE_RECURRING": {
      return {
        ...state,
        recurring: action.payload,
      };
    }
    default: {
      return {
        ...state,
        [action.target.name]: action.target.value,
      };
    }
  }
}

// Doctor related filter search form
export default function PatientFilterForm({ patientList }) {
  const filter_status = {
    gender: useSelector((state) => state.patientFilterReducer.gender),
    created_at: useSelector((state) => state.patientFilterReducer.value2),
    appoint_date_from: useSelector(
      (state) => state.patientFilterReducer.value3
    ),
    os_name: useSelector((state) => state.patientFilterReducer.os_name),
    user_type: useSelector((state) => state.patientFilterReducer.user_type),
    recurring: useSelector((state) => state.patientFilterReducer.recurring),
  };
  const [formData, setFormDataDispatch] = React.useReducer(filterReducer, {
    gender: filter_status.gender,
    created_at: filter_status.created_at,
    appoint_date_from: filter_status.appoint_date_from,
    os_name: filter_status.os_name,
    user_type: filter_status.user_type,
    recurring: filter_status.recurring,
    loading: false,
  });

  const dispatch = useDispatch();

  const {
    created_at,
    gender,
    appoint_date_from,
    os_name,
    user_type,
    recurring,
    loading,
  } = formData;

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormDataDispatch({ type: "LOADING_TRUE" });

    if (appoint_date_from !== undefined) {
      dispatch({
        type: "patientFilter/appoint_date_from",
        payload: appoint_date_from,
      });
    }

    if (created_at !== undefined) {
      dispatch({
        type: "patientFilter/created_at",
        payload: created_at,
      });
    }

    if (gender !== filter_status.gender) {
      dispatch({
        type: "patientFilter/gender",
        payload: gender,
      });
    }
    if (os_name !== filter_status.os_name) {
      dispatch({
        type: "patientFilter/os_name",
        payload: formData.os_name,
      });
    }

    if (user_type !== filter_status.user_type) {
      dispatch({
        type: "patientFilter/user_type",
        payload: formData.user_type,
      });
    }

    if (recurring !== filter_status.recurring) {
      dispatch({
        type: "patientFilter/recurring",
        payload: recurring,
      });
    }
    setTimeout(() => {
      setFormDataDispatch({ type: "LOADING_FALSE" });
      dispatch({ type: "tableFilterModal/setHideModal" });
    }, 1000);
  };
  const handleRecurringChange = (event) => {
    const isChecked = event.target.checked;
    setFormDataDispatch({
      type: "TOGGLE_RECURRING",
      payload: isChecked ? 1 : 0, // Set to 1 if checked (recurring), 0 if unchecked (non-recurring)
    });
  };
  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="mt-4 d-flex flex-column justify-content-center align-items-center"
      >
        <div className="form-group mt-3 w-100 px-2">
          <div>
            <input
              type="checkbox"
              id="recurringCheckbox"
              name="recurring"
              checked={recurring === 1} // Checked if recurring is 1
              onChange={handleRecurringChange}
              className="form-check-input custom-checkbox"
            />
            <label
              htmlFor="recurringCheckbox"
              className="form-check-label ms-2"
              style={{ fontWeight: 400 }}
            >
              Show Recurring Users
            </label>
          </div>
        </div>

        <div className="form-group mt-3 w-100 px-2">
          <label htmlFor="typeSelect" style={{ fontWeight: 400 }}>
            Patients
          </label>
          <select
            className="form-control"
            id="typeSelect"
            onChange={setFormDataDispatch}
            name="user_type"
            defaultValue={formData.user_type}
          >
            <option value="All">All Patients</option>
            <option value="verified">Verified Patients</option>
            <option value="unverified">Unverified Patients</option>
          </select>
        </div>

        <div className="form-group mt-3 w-100 px-2">
          <label htmlFor="deviceSelect" style={{ fontWeight: 400 }}>
            Device
          </label>
          <select
            className="form-control"
            id="deviceSelect"
            onChange={setFormDataDispatch}
            name="os_name"
            defaultValue={formData.os_name}
          >
            <option value="All">All Device</option>
            <option value="android">Android</option>
            <option value="web">Web</option>
            <option value="ios">Ios</option>
          </select>
        </div>

        <div className="form-group mt-3 w-100 px-2">
          <label
            htmlFor="exampleFormControlSelect1"
            style={{ fontWeight: 400 }}
          >
            Gender
          </label>
          <select
            className="form-control"
            id="exampleFormControlSelect1"
            onChange={setFormDataDispatch}
            name="gender"
            defaultValue={formData.gender}
          >
            <option value="all">All</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="form-group mt-3 px-2 w-100">
          <label
            htmlFor="exampleFormControlSelect1"
            style={{ fontWeight: 400 }}
          >
            Registered Date From
          </label>
          <input
            onChange={setFormDataDispatch}
            name="appoint_date_from"
            type="date"
            className="form-control filter-input"
            id="exampleFormControlSelect2"
            value={appoint_date_from}
          />
        </div>

        <div className="form-group mt-3 px-2 w-100">
          <label
            htmlFor="exampleFormControlSelect1"
            style={{ fontWeight: 400 }}
          >
            Registered Date To
          </label>
          <input
            onChange={setFormDataDispatch}
            name="created_at"
            type="date"
            className="form-control filter-input"
            id="exampleFormControlSelect2"
            value={created_at}
          />
        </div>

        <button className="btn mt-3 filter-form-button">
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              style={{ marginRight: "20px" }}
            />
          )}{" "}
          {loading || "Apply"}
        </button>
      </form>
      <style jsx="true">{`
        .filter-form-button {
          background: #009b93;
          color: #fff;
          width: 95%;
        }
        .filter-form-button:hover {
          color: #fff;
          background: #009b93 !important;
        }
        .filter-input:focus {
          border-color: #009b93 !important;
          box-shadow: 0 0 0 0.2rem rgba(0, 155, 148, 25%) !important;
        }
        select option:hover {
          background: #009b93 !important;
        }
        .custom-checkbox {
          width: 1.2em;
          height: 1.2em;
          border: 2px solid #009b93;
          border-radius: 4px;
          appearance: none;
          outline: none;
          cursor: pointer;
          margin: 0 0 3px;
          vertical-align: middle;
        }
        .custom-checkbox:checked {
          background-color: #009b93; /* Apply background color when checked */
          border-color: #009b93;
        }
        .custom-checkbox:checked::after {
          color: white;
          font-size: 0.6em;
          text-align: center;
          display: block;
          line-height: 1.1em;
        }
      `}</style>
    </>
  );
}
